export const addInterviewee = '/interviewee';
export const interviewee = '/interviewee';
export const updateInterviewee = '/interviewee/';
export const promoteAsIntern = '/intern/';
export const updateIntervieweeStatus = '/interviewee/updateIntervieweeStatus/';
export const searchCandidateInterviewee = '/user/searchCandidatesForInterview';
export const searchInterviewee = '/interviewee/searchInterviewee';
